<template>
  <div>
    <cham-block animation-class="slideInDown">
      <cham-header main-title="Post Title ;" subtitle=""/>
        <span class="line">15th Jan 2017</span>
        <div class="section columns">
          <div class="column is-8 is-offset-2 ">
            <figure class="image img-shawod">
              <img src="../../assets/blog.jpg">
            </figure>
          </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <section class="interaction line">
            <i class="fa fa-comment"></i> 100
            <i class="fa fa-eye"></i> 500,000
          </section>
        </div>
      </div>


      <div class="section columns">
        <div class="column is-12">
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi, aliquid. Cum commodi ea dignissimos rem cupiditate magni quidem! Rem earum perferendis cupiditate totam? Facere ut nemo nisi esse, illum laudantium?
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-4 is-offset-8 social">
          <section class="interaction line">
            <social-sharing url="https://vuejs.org/"
              title="The Progressive JavaScript Framework"
              description="Intuitive, Fast and Composable MVVM for building interactive interfaces."
              quote="Vue is a progressive framework for building user interfaces."
              hashtags="vuejs,javascript,reactjs,laravel,php,reactnative"
              twitter-user="cha_m_ra"
              inline-template >
                <div class="level is-mobile social">
                  <network network="email" >
                      <i class="fa fa-envelope"></i>
                  </network>
                  <network network="facebook" >
                    <i class="fa fa-facebook"></i>
                  </network>
                  <network network="twitter" >
                    <i class="fa fa-twitter"></i>
                  </network>
                  <network network="googleplus">
                    <i class="fa fa-google-plus"></i>
                  </network>
                  <network network="linkedin">
                    <i class="fa fa-linkedin"></i>
                  </network>
                  <network network="reddit">
                    <i class="fa fa-reddit"></i>
                  </network>
                  <network network="sms">
                    <i class="fa fa-commenting-o"></i>
                  </network>
                  <network network="telegram">
                    <i class="fa fa-telegram"></i>
                  </network>
              </div>
            </social-sharing>
          </section>
        </div>
      </div>


      <div class="section columns">
        <div class="column">
          <cham-comment></cham-comment>
        </div>
      </div>

    </cham-block>
  </div>
</template>

<script>
  import SocialSharing from 'vue-social-sharing';

  // Vue.use(SocialSharing);

  export default {
    name : 'SinglePost',
    mounted () {
      document.title = "Post Title"
    },
    components : {
      SocialSharing
    }
  }
</script>

<style lang="scss">
@import '../../../static/styles.scss';
.social span{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/componests/pages/SinglePost.vue